import BreadCrumb from '../../../../components/Breadcrumb/breadCrumb'
import steps from '../../../../components/steps/steps'
import titleLine from '../../../../components/titleLine/titleLine'
import noData from '../../../../components/noData/noData'
import {
  interSt
} from '@/utils/appointment.url.js' // 引入接口
import {
  Loading
} from 'element-ui'
export default {
    data: function () {
        return {
            dataList: [],
            loading: false
        }
    },
    components: {
        BreadCrumb,
        steps,
        titleLine,
        noData
      },
    methods: {
        // 点击列表
        clickList (item) {
            console.log(item);
            if (item.service == 1) {
                 window.location = item.pcUrl;
                 return;
            }
            this.$router.push({
                path: '/businessType',
                query: {
                  serTypeSeq: item.seq, 
                  areaSeq: this.$route.query.areaSeq
                }
              })
        },
        // 获取服务类型
        getData () {
            this.loading = true;
            interSt({
                loginaware: true,                
              },
              'get'
            ).then(res => {
              this.loading = false;
              if (res.status == '200') {
                this.dataList = res.data.list;
                // 未开启预约服务类型时
                if (res.data.seStart == 1) {
                    this.$router.push({
                        path: '/businessType',
                        query: {
                          serTypeSeq: '', 
                          areaSeq: this.$route.query.areaSeq
                        }
                      })
                }
              } else {
                this.$message.error(res.desc)
              }
            })
            .catch(err => {
              console.log(err)
            })
        }
    },
    mounted () {
        this.getData();
        // 存储带入的areaSeq
        sessionStorage.setItem("areaSeq", this.$route.query.areaSeq);
    },  
}
